import { createMemo, Show } from 'solid-js'
import { m } from '~/paraglide/messages'

export function useCountdown(
  params: () => { now: Date; endDate: Date; includesDay?: boolean },
) {
  return createMemo(() => {
    const { now, endDate, includesDay } = params()
    const diff = endDate.getTime() - now.getTime()
    const day = Math.floor(diff / (1000 * 60 * 60 * 24))
    const hours = includesDay
      ? Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      : Math.floor(diff / (1000 * 60 * 60))
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
    return {
      day,
      hours,
      minutes,
      text: (
        <span>
          <Show when={params().includesDay}>
            {m.countdown_day({ day: String(day) })}
          </Show>{' '}
          {m.countdown_hour({ hour: String(hours) })}{' '}
          {m.countdown_minute({ minute: String(minutes) })}
        </span>
      ),
    }
  })
}
